import type React from "react";
import {memo} from "react";
import {useParams} from "react-router-dom";

import {useLevelV2} from "~/api/hooks/useLevelV2";
import AppHeader from "~/component/common/AppHeader";

import type {PlayLevelParams} from "./PlayLevelParams";
import {RestartButton} from "./buttons/RestartButton";
import PlayMenuModalButton from "./play-menu/PlayMenuModalButton";

const PlayLevelHtml: React.FC = memo(() => {
  const {id, playlistId} = useParams<PlayLevelParams>();
  const {data: level} = useLevelV2({id});

  // Determine parent path based on whether we have a playlist ID
  const parentPath = playlistId ? `/playlist/${playlistId}` : "/play";

  return (
    <div className="flex flex-col w-screen min-h-screen overflow-auto relative text-white bg-transparent pointer-events-none">
      <AppHeader title={level?.name} parentPath={parentPath} />
      <div className="fixed bottom-2 left-1/2 transform -translate-x-1/2 flex items-center space-x-4 z-50 pointer-events-auto">
        <RestartButton />
        <PlayMenuModalButton />
      </div>
    </div>
  );
});

export default PlayLevelHtml;
